import React from 'react';

const PRIORITY_STYLES = {
  'Crítica': {
    bg: 'bg-gradient-to-r from-red-500 to-red-600',
    text: 'text-white',
    border: 'border-red-500',
    glow: 'shadow-[0_0_12px_rgba(239,68,68,0.5)]',
    pulse: true
  },
  'Alta': {
    bg: 'bg-gradient-to-r from-orange-500 to-orange-600',
    text: 'text-white',
    border: 'border-orange-500',
    glow: 'shadow-[0_0_10px_rgba(249,115,22,0.4)]'
  },
  'Media': {
    bg: 'bg-gradient-to-r from-blue-500 to-blue-600',
    text: 'text-white',
    border: 'border-blue-500',
    glow: 'shadow-[0_0_8px_rgba(59,130,246,0.3)]'
  },
  'Baja': {
    bg: 'bg-gradient-to-r from-gray-500 to-gray-600',
    text: 'text-white',
    border: 'border-gray-500',
    glow: 'shadow-[0_0_6px_rgba(107,114,128,0.3)]'
  }
};

const PriorityBadge = ({ priority, className = '' }) => {
  const style = PRIORITY_STYLES[priority] || PRIORITY_STYLES['Media'];

  return (
    <span
      className={`inline-flex items-center px-3 py-1.5 rounded-full text-xs font-bold border-2 ${style.bg} ${style.text} ${style.border} ${style.glow} ${style.pulse ? 'animate-pulse' : ''} ${className}`}
      data-testid="priority-badge"
    >
      {priority === 'Crítica' && '🔥 '}
      {priority}
    </span>
  );
};

export default PriorityBadge;
